import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_the_fac_failing_to_implement_measures_regarding_housingdormi'

export const dataPointDefinition = {
  retracedId: 'is_the_fac_failing_to_implement_measures_regarding_housingdormi',
  name: 'Is the facility failing to implement measures regarding housing/dormitories?',
  description:
    'Housing means any type of accommodation that can consist of an entire residential building, or just one flat, apartment, or room. This question is linked to the Facility Profile question asking about on-site dormitories or off-site housing or dormitories managed by the facility.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'HOUSING_DORMITORIES_ARE_NOT_SEPARATE_FROM_THE_PRODUCTION_AND_WA',
      text: 'Housing/dormitories are not separate from the production and warehouse areas (even though they may be in the same compound/industrial park)',
      externalIds: [
        {
          id: 'hs-dor-9',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOUSING_DORMITORIES_ARE_NOT_CLEAN',
      text: 'Housing/dormitories are not clean',
      externalIds: [
        {
          id: 'hs-dor-10',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOUSING_DORMITORIES_MINIMUM_SPACE_DIMENSIONS_ARE_OUT_OF_LINE_WI',
      text: 'Housing/dormitories minimum space dimensions are out of line with legal requirements',
      externalIds: [
        {
          id: 'hs-dor-11',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'BEDS_ARE_ARRANGED_MORE_THAN_TWO_TIERS_HIGH',
      text: 'Beds are arranged more than two tiers high',
      externalIds: [
        {
          id: 'hs-dor-12',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOUSING_DORMITORIES_ARE_NOT_LIT_IN_LINE_WITH_LEGAL_REQUIREMENTS',
      text: 'Housing/dormitories are not lit in line with legal requirements',
      externalIds: [
        {
          id: 'hs-dor-13',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOUSING_DORMITORIES_ARE_NOT_VENTILATED_IN_LINE_WITH_LEGAL_REQUI',
      text: 'Housing/dormitories are not ventilated in line with legal requirements',
      externalIds: [
        {
          id: 'hs-dor-14',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOUSING_DORMITORIES_PROTECTION_AGAINST_HEAT_COLD_AND_DAMPNESS_I',
      text: 'Housing/dormitories protection against heat, cold, and dampness is out of line with legal requirements',
      externalIds: [
        {
          id: 'hs-dor-15',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOUSING_DORMITORIES_NOISE_PROTECTION_IS_OUT_OF_LINE_WITH_LEGAL_',
      text: 'Housing/dormitories noise protection is out of line with legal requirements',
      externalIds: [
        {
          id: 'hs-dor-16',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOUSING_DORMITORIES_PROTECTION_AGAINST_DISEASE_CARRYING_ANIMALS',
      text: 'Housing/dormitories protection against disease carrying animals or insects is out of line with legal requirements',
      externalIds: [
        {
          id: 'hs-dor-17',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOUSING_DORMITORIES_COOKING_AND_STORAGE_FACILITIES_ARE_OUT_OF_L',
      text: 'Housing/dormitories cooking and storage facilities are out of line with legal requirements',
      externalIds: [
        {
          id: 'hs-dor-18',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOUSING_DORMITORIES_OFFER_WORKERS_ADEQUATE_PRIVACY',
      text: 'Housing/dormitories offer workers adequate privacy',
      externalIds: [
        {
          id: 'hs-dor-19',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOUSING_DORMITORIES_ACCESS_TO_FREE_AND_POTABLE_WATER_IS_OUT_OF_',
      text: 'Housing/dormitories access to free and potable water is out of line with legal requirements',
      externalIds: [
        {
          id: 'hs-dor-20',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOUSING_DORMITORIES_DO_NOT_HAVE_LEGALLY_REQUIRED_TOILETS_SHOWER',
      text: 'Housing/dormitories do not have legally required toilets, showers, sewage and garbage disposal system',
      externalIds: [
        {
          id: 'hs-dor-21',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOUSING_DORMITORIES_PROTECTION_FROM_FIRE_IS_OUT_OF_LINE_WITH_LE',
      text: 'Housing/dormitories protection from fire is out of line with legal requirements',
      externalIds: [
        {
          id: 'hs-dor-22',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOUSING_DORMITORIES_EMERGENCY_PREPAREDNESS_IS_OUT_OF_LINE_WITH_',
      text: 'Housing/dormitories emergency preparedness is out of line with legal requirements',
      externalIds: [
        {
          id: 'hs-dor-23',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE_THE_FACILITY_IS_MEETING_ALL_MEASURES_LISTED_R',
      text: 'None of the above (the facility is meeting all measures listed regarding housing/dormitories)',
      externalIds: [
        {
          id: 'hs-dor-24',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DOES_HOUSING_DORMITORIES_PROVIDE_PROVISIONS_FOR_PREGNANT_AND_NU',
      text: 'Does housing/dormitories provide provisions for pregnant and nursing mothers?',
      externalIds: [
        {
          id: 'hs-dor-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DOES_HOUSING_DORMITORIES_HAVE_TRAINED_SECURITY_PERSONNEL_',
      text: 'Does housing/dormitories have trained security personnel?',
      externalIds: [
        {
          id: 'hs-dor-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DOES_HOUSING_DORMITORIES_OFFER_SUFFICIENT_STORAGE_SPACE_FOR_WOR',
      text: 'Does housing/dormitories offer sufficient storage space for workers?',
      externalIds: [
        {
          id: 'hs-dor-25',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ARE_HOUSING_DORMITORIES_IN_LINE_WITH_ALL_OTHER_HEALTH_AND_SAFET',
      text: 'Are housing/dormitories in line with all other health and safety legal requirements?',
      externalIds: [
        {
          id: 'hs-55--3',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ARE_BUILDING_CONSTRUCTION_STRUCTURAL_SAFETY_AND_FIRE_PERMITS_AN',
      text: 'Are building/construction, structural safety and fire permits and certificates for off-site housing sites not managed and controlled by the facility in line with legal requirements?',
      externalIds: [
        {
          id: 'hs-dor-26',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ARE_ONSITE_CANTEENS_IN_LINE_WITH_LEGAL_REQUIREMENTS_',
      text: 'Are onsite canteens in line with legal requirements?',
      externalIds: [
        {
          id: 'hs-56--1',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ARE_OFF_SITE_CANTEENS_MANAGED_BY_THE_FACILITY_IN_LINE_WITH_LEGA',
      text: 'Are off-site canteens managed by the facility in line with legal requirements?',
      externalIds: [
        {
          id: 'hs-can-2',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'HOUSING_DORMITORIES_ARE_NOT_SEPARATE_FROM_THE_PRODUCTION_AND_WA',
                'HOUSING_DORMITORIES_ARE_NOT_CLEAN',
                'HOUSING_DORMITORIES_MINIMUM_SPACE_DIMENSIONS_ARE_OUT_OF_LINE_WI',
                'BEDS_ARE_ARRANGED_MORE_THAN_TWO_TIERS_HIGH',
                'HOUSING_DORMITORIES_ARE_NOT_LIT_IN_LINE_WITH_LEGAL_REQUIREMENTS',
                'HOUSING_DORMITORIES_ARE_NOT_VENTILATED_IN_LINE_WITH_LEGAL_REQUI',
                'HOUSING_DORMITORIES_PROTECTION_AGAINST_HEAT_COLD_AND_DAMPNESS_I',
                'HOUSING_DORMITORIES_NOISE_PROTECTION_IS_OUT_OF_LINE_WITH_LEGAL_',
                'HOUSING_DORMITORIES_PROTECTION_AGAINST_DISEASE_CARRYING_ANIMALS',
                'HOUSING_DORMITORIES_COOKING_AND_STORAGE_FACILITIES_ARE_OUT_OF_L',
                'HOUSING_DORMITORIES_OFFER_WORKERS_ADEQUATE_PRIVACY',
                'HOUSING_DORMITORIES_ACCESS_TO_FREE_AND_POTABLE_WATER_IS_OUT_OF_',
                'HOUSING_DORMITORIES_DO_NOT_HAVE_LEGALLY_REQUIRED_TOILETS_SHOWER',
                'HOUSING_DORMITORIES_PROTECTION_FROM_FIRE_IS_OUT_OF_LINE_WITH_LE',
                'HOUSING_DORMITORIES_EMERGENCY_PREPAREDNESS_IS_OUT_OF_LINE_WITH_',
                'NONE_OF_THE_ABOVE_THE_FACILITY_IS_MEETING_ALL_MEASURES_LISTED_R',
                'DOES_HOUSING_DORMITORIES_PROVIDE_PROVISIONS_FOR_PREGNANT_AND_NU',
                'DOES_HOUSING_DORMITORIES_HAVE_TRAINED_SECURITY_PERSONNEL_',
                'DOES_HOUSING_DORMITORIES_OFFER_SUFFICIENT_STORAGE_SPACE_FOR_WOR',
                'ARE_HOUSING_DORMITORIES_IN_LINE_WITH_ALL_OTHER_HEALTH_AND_SAFET',
                'ARE_BUILDING_CONSTRUCTION_STRUCTURAL_SAFETY_AND_FIRE_PERMITS_AN',
                'ARE_ONSITE_CANTEENS_IN_LINE_WITH_LEGAL_REQUIREMENTS_',
                'ARE_OFF_SITE_CANTEENS_MANAGED_BY_THE_FACILITY_IN_LINE_WITH_LEGA',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-dor-8',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17230,
  sectionId: '2.2.9.10',
  impactArea: 'Accommodation & Dormitories',
  impactAreaId: 'ACCOMODATION_AND_DORMITORIES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
